import { render, staticRenderFns } from "./courseManagement.vue?vue&type=template&id=2772d408&scoped=true"
import script from "./courseManagement.vue?vue&type=script&lang=js"
export * from "./courseManagement.vue?vue&type=script&lang=js"
import style0 from "./courseManagement.vue?vue&type=style&index=0&id=2772d408&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772d408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2772d408')) {
      api.createRecord('2772d408', component.options)
    } else {
      api.reload('2772d408', component.options)
    }
    module.hot.accept("./courseManagement.vue?vue&type=template&id=2772d408&scoped=true", function () {
      api.rerender('2772d408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/courseManagement.vue"
export default component.exports